const class_names = (...classes: string[]) => classes.filter(Boolean).join(' ');

export { class_names };
